// extracted by mini-css-extract-plugin
export default {"chip":"CourseType_chip__i6qgy","chip__recorded":"CourseType_chip__recorded__FAygE","chip__live":"CourseType_chip__live__FrFJv"};